export interface GameConfig {
  lanes: number;
  laneWidth: number;
  roadWidth: number;
  baseSpeed: number;
  maxSpeed: number;
  speedIncrement: number;
  obstacleSpawnInterval: number;
  itemSpawnInterval: number;
  playerStartLane: number;
}
export interface ObstacleConfig {
  type: 'pothole' | 'barrier' | 'cone';
  width: number;
  height: number;
  color: number;
}
export interface ItemConfig {
  type: 'speed' | 'fly' | 'shield' | 'score';
  width: number;
  height: number;
  color: number;
  duration: number;
}
export const GAME_CONFIG: GameConfig = {
  lanes: 3,
  laneWidth: 80,
  roadWidth: 240,
  baseSpeed: 5,
  maxSpeed: 15,
  speedIncrement: 0.5,
  obstacleSpawnInterval: 1500,
  itemSpawnInterval: 3000,
  playerStartLane: 1,
};
export const OBSTACLE_TYPES: Record<string, ObstacleConfig> = {
  pothole: { type: 'pothole', width: 50, height: 30, color: 0x2d2d2d },
  barrier: { type: 'barrier', width: 60, height: 40, color: 0xff4444 },
  cone: { type: 'cone', width: 30, height: 35, color: 0xff8800 },
};
export const ITEM_TYPES: Record<string, ItemConfig> = {
  speed: { type: 'speed', width: 40, height: 40, color: 0x00ff88, duration: 5000 },
  fly: { type: 'fly', width: 40, height: 40, color: 0x00aaff, duration: 4000 },
  shield: { type: 'shield', width: 40, height: 40, color: 0xffff00, duration: 3000 },
  score: { type: 'score', width: 35, height: 35, color: 0xff00ff, duration: 0 },
};
export const COLORS = {
  road: 0x333333,
  roadLine: 0xffffff,
  player: 0x4488ff,
  background: 0x87ceeb,
  sky: 0x1a1a2e,
};